import { useMemo } from 'react';

import { useShowCause } from 'core/Api';
import { WalletEntryCard } from 'core/Components';
import { cartItemDisplayName } from 'core/Utils';
import { DateTime } from 'luxon';
import { useNavigate } from 'react-router-dom';
import { CartItem } from 'store/Api';
import { DEFAULT_BRAND_IMAGE } from 'ui';

import { absCentsToDollar } from '../../../../utils/centsToDollar';

const PurchaseDetailCard = ({ cartItem }: { cartItem: CartItem }) => {
  const navigate = useNavigate();
  const { data: causeData } = useShowCause(cartItem.store_item.cause_id);

  /** Returns the purchase date string if available or '' to prevent errors */
  const purchasedAt = useMemo(() => {
    if (!cartItem.cart?.purchased_at) return '';
    return DateTime.fromISO(cartItem.cart?.purchased_at).toFormat('MM/dd/yy');
  }, [cartItem.cart?.purchased_at]);
  const isRefund = !!cartItem.reversed_at;
  const timestamp = cartItem.cart?.status === 'pledged' ? 'Pending' : purchasedAt;

  const title = useMemo(() => {
    let str = '';
    if (isRefund) {
      str = 'Refund - ';
    }
    if (cartItem.store_item.type === 'StoreItems::Item') {
      return `${str}${cartItem.store_item.name} Purchase`;
    }
    return cartItemDisplayName(cartItem);
  }, [cartItem, isRefund]);

  return (
    <WalletEntryCard
      image={causeData?.thumbnail?.url || DEFAULT_BRAND_IMAGE}
      title={title}
      subtitle={causeData?.name}
      amount={absCentsToDollar(Number(cartItem.total))}
      isFailed={isRefund}
      subText={timestamp}
      onClick={() => navigate(`${cartItem.uuid}`)}
    />
  );
};

export { PurchaseDetailCard };
